<template>
   <div :class="[page.class, 'bio block pt-16']">
        <!-- <h1>{{page.page_title}}</h1> -->
        <ul class="p-container">
            <li v-for="item, index in items" :key="item.id" class="w-full mb-32">
                <ul v-if="index % 2 == 0" class="flex flex-left">
                    <li class="w-full md:w-1/2 pl-4 p-left">
                        <h2 class="text-2xl">{{item.objectable.title}}</h2>
                        <span v-html="item.objectable?.content"></span>
                    </li>
                    <li v-if="item?.objectable?.image" class="w-full md:w-1/2 p-right">
                        <img :src="buildPath(item.objectable?.image)" :alt="item.objectable?.title" class="mr-4 w-3/4 mt-2 object-fit float-right"></li>
                </ul>
                <ul v-else class="flex flex-wrap">
                    <li v-if="item?.objectable?.image" class="w-full md:w-1/2 pl-8 p-left"><img :src="buildPath(item.objectable?.image)" :alt="item.objectable?.title" class="mt-2 w-3/4 object-contain"></li>
                    <li class="w-full md:w-1/2 pl-4 p-right">
                    <h2 class="text-2xl">{{item.objectable.title}}</h2>
                        <span v-html="item.objectable?.content"></span>
                    </li>

                </ul>
            </li>
        </ul>
   </div>
</template>

<script>

import { onScroll, animate } from 'animejs';
export default {
    name: "BioPage",
    props: ['page'],
    computed: {
        items() {
            return this.page?.page_objects;
        }
    },
    data() {
        return {
            size: '854x480',
        }
    },
    mounted() {
        animate('.p-left', { opacity: 1, x: 20, autoplay: onScroll({container: '.p-container', target: '.p-left', axis: 'y', sync: 'play reverse', debug: false}) });
        animate('.p-right', { opacity: 1, x: -20, autoplay: onScroll({container: '.p-container', axis: 'y', sync: 'play reverse', debug:false}) });

    },
    methods: {
        buildPath(i) {
            if(!i) return;
            return `/storage/webp/${i.filename}-${this.size}.webp`;
        },
    }
}
</script>
<style lang="postcss">
.p-left, .p-right {
    opacity: 0;
}
.p-left {
    transform: translateX(-20px);
}
.bio h2 {
    font-weight: 300;
    font-size: 1.3em;
    color: rgba(0,0,0,.7);
}
</style>
